(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for one the appointment types dropdown 
    module.directive('agendaAppointmentLabels', ['$rootScope', 'AppointmentDetailService', function ($rootScope, AppointmentDetailService) {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-labels.template.html',
            require: '^form',
            scope: {
                model: '=', // the current selected item
                labels: '=' // possible list of agenda-labels of agenda
            },
            link: link
        };
        return directive;

        function link(scope, element, attrs, formCtrl) {

            activate();

            function activate() {

                /// set default selected agenda-label by selected time (if selected)
                if (scope.model) {
                    var found = false;

                    var i = 0;
                    var len = scope.labels.length;
                    for (i = 0; i < len; i++) {
                                                
                        var label = scope.labels[i];
                        // search agendalabel by appointmentId or by time
                        if (
                            (scope.model.appointmentId && label.appointmentId === scope.model.appointmentId)
                            || 
                            (label.hour === scope.model.hour && label.minute === scope.model.minute)
                            ) {
                                
                            select(label, false);
                            found = true;
                            break;
                        } // if  
                    } // for

                    // if none found -> select first from list
                    if (!found) {
                        if (scope.labels.length > 0) {
                            select(scope.labels[0], false);
                        } // if
                        else {
                            // nothing to select
                            select(null, false);
                        } // else
                    } // if

                } //if
            } // activate

            // check if label is in the past
            function inThePast() {
                if (!scope.model) {
                     return; 
                }

                // set time to service
                AppointmentDetailService.data.time.hour = scope.model.hour;
                AppointmentDetailService.data.time.minute = scope.model.minute;
                
                // force time check
                AppointmentDetailService.data.doTimeChecks = true;

                AppointmentDetailService.inThePast().then(function (result) {
                    formCtrl.$setValidity("inThePast", !result);
                });
            }

            // field is required
            function required() {
                if (!scope.model) {
                    formCtrl.$setValidity("noLabel", false);
                }
                else {
                    formCtrl.$setValidity("noLabel", true);
                }
            }

            // select new agenda label
            function select(label, validateTimeInThePast) {
                scope.model = label;
                
                // check time is in the past if parameter validateTimeInThePast is true
                if (validateTimeInThePast) {
                    inThePast();
                }
                // required
                required();
            }


            // select agenda label
            scope.select = select;


        } // link

    }]);

})();